import React, { ReactNode } from 'react';

import { EyeOpen } from '@xsolla/ui-icons';
import { useModal } from '@xsolla/ui-modal';

import { project_colors } from '../../../constants';
import ExampleWidgetModal from './ExampleWidgetModal';
import {
  CardSubtitle,
  CardTitle,
  CardWrapper,
  ExampleImage,
  IconWrapper,
  TextWrapper
} from './style';

interface Props {
  title: ReactNode;
  subtitle: ReactNode;
  imageSrc: ReactNode;
  firstModalImgExample: ReactNode;
  secondModalImgExample?: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
}

const ExampleWidgetCard = ({
  title,
  subtitle,
  imageSrc,
  isActive,
  firstModalImgExample,
  secondModalImgExample,
  onClick
}: Props): JSX.Element => {
  const [onOpenModal, onCloseModal] = useModal(
    () => (
      <ExampleWidgetModal
        firstImgExampleSrc={firstModalImgExample}
        secondImgExampleSrc={secondModalImgExample}
        size="lg"
        onClose={onCloseModal}>
        ....
      </ExampleWidgetModal>
    ),
    []
  );
  return (
    <CardWrapper data-test-id={`login-method-${title}`} onClick={onClick} isActive={!!isActive}>
      <TextWrapper>
        <CardTitle>{title}</CardTitle>
        <CardSubtitle>{subtitle}</CardSubtitle>
      </TextWrapper>
      <IconWrapper data-test-id={`btn-open-preview-${title}`} onClick={onOpenModal}>
        <EyeOpen color={project_colors.NEUTRAL_LIGHT} />
      </IconWrapper>
      <ExampleImage>{imageSrc}</ExampleImage>
    </CardWrapper>
  );
};

export default ExampleWidgetCard;
